export const getGTMData = service => {
  const {
    displayName: name,
    skuId: id,
    price
  } = (service || {})

  return {
    name,
    id,
    price: Number(price) < 0 ? 0 : price,
    brand: name,
    category: 'Services',
    list: 'Product Detail',
    position: 1
  }
}
